import React from 'react';
import { NeoReport, Report } from "@singularsystems/neo-reporting";
import { MaintenanceReportCategories } from '../MaintenanceReportCategories';
import { Layout } from '@singularsystems/neo-canvas-grid';
import ExportFilesSentReportCriteria from './ExportFilesSentReportCriteria';
import { Neo } from '@singularsystems/neo-react';
import { TextConstants } from '../../../Common/TextConstants';


@NeoReport("ExportFilesSent",  { category: MaintenanceReportCategories.SystemInformationReports})
export default class ExportFilesSentReport extends Report<ExportFilesSentReportCriteria>{

    constructor() {
        super(ExportFilesSentReportCriteria);
    }

    public renderCriteria() {
        return (
        <>
            <Neo.FormGroup 
                label={TextConstants.Labels.Date}
                bind={this.criteria.meta.dateReport}
                appendText="fa-calendar"
                dateProps={{ formatString: "dd MMM yyyy"}} />
        </>
        );
    }

    public getDefaultGridLayout() {
        return {
            "root": {
            }
        } as Layout.IGridLayout;
    }
}